define('OutSystems/ClientRuntime/Utils',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StringUtils = void 0;
    var StringUtils = (function () {
        function StringUtils() {
        }
        StringUtils.safeParseInt = function (str) {
            var retValue = str;
            if (!!str && !isNaN(Number(str))) {
                retValue = parseInt(str, 10);
            }
            return retValue;
        };
        return StringUtils;
    }());
    exports.StringUtils = StringUtils;
});
//# sourceMappingURL=Utils.js.map;
